"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFmErrorDetail = extractFmErrorDetail;
exports.formatPinPostToHeaderError = formatPinPostToHeaderError;
const errors_1 = require("../errors");
/**
 * Текст ошибки из ответа `fm` (как Android `c0179y.l(1).n(0)`).
 * В логгере официального клиента вложенный массив часто не виден — там пустая строка.
 */
function extractFmErrorDetail(data) {
    if (!Array.isArray(data) || data.length < 2)
        return null;
    const second = data[1];
    if (typeof second === 'string' && second.trim())
        return second.trim();
    if (Array.isArray(second)) {
        for (const item of second) {
            if (typeof item === 'string' && item.trim())
                return item.trim();
        }
    }
    return null;
}
function localizeFmDetail(detail) {
    const lower = detail.toLowerCase();
    if (lower.includes('no post'))
        return 'пост не найден (возможно, удалён)';
    if (lower.includes('deleted'))
        return 'пост удалён';
    if ((lower.includes('already') || lower.includes('уже'))
        && (lower.includes('pin') || lower.includes('hat') || lower.includes('header') || lower.includes('шапк'))) {
        return 'пост уже в шапке';
    }
    if (lower.includes('pinned') || lower.includes('in header'))
        return 'пост уже в шапке';
    if (lower.includes('no access'))
        return 'недостаточно прав';
    return detail;
}
/** Сообщение для `fm` action 6 / ссылки `zmod&CODE=update-pinned` (как Android Toast). */
function formatPinPostToHeaderError(error) {
    if (error instanceof errors_1.FourPdaError) {
        const detail = extractFmErrorDetail(error.data);
        if (detail) {
            return `Не удалось поднять пост в шапку: ${localizeFmDetail(detail)}`;
        }
        if (error.command === 'fm' && error.code === 3) {
            return 'Не удалось поднять пост в шапку';
        }
        return error.message;
    }
    if (error instanceof Error)
        return error.message;
    return 'Не удалось поднять пост в шапку';
}
